<script setup lang="ts">
withDefaults(defineProps<{ code: string; size?: 'sm' | 'md' }>(), { size: 'md' })
</script>

<template>
  <!--
    `rounded-full` is a documented exception, not a slip. The design system sets
    `--radius: 0` and requires rectangles, permitting `rounded-full` only for
    GENUINELY circular elements — it already lists the Switch knob, map stop dots
    and the user-location dot. A route-code chip is circular in every mockup and
    qualifies on the same grounds. See .trellis/spec/frontend/design-system.md.

    Long codes (`04CT`, `101A`, `BRT01`) must not stretch the circle, so the text
    scales down rather than the badge growing.
  -->
  <span
    class="flex shrink-0 items-center justify-center rounded-full bg-primary text-center font-bold text-primary-foreground"
    :class="size === 'sm' ? 'size-8' : 'size-11'"
  >
    <span :class="code.length > 3 ? 'text-[0.625rem] leading-tight' : 'text-sm'">{{ code }}</span>
  </span>
</template>
